<template>
  <div  class="preventclick" >
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Curriculum
                </div>
              </div>
              <v-col cols="12" lg="6" v-if="getList.length > 0"><b>Classes</b> :<br />
                {{ getList }}
              </v-col>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
              style="opacity: 0.6">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </v-card-actions>
        <v-dialog v-model="renameModal" persistent width="500" :active="renameModal" :on-cancel="() => {
          renameModal = false;
        }
          ">
          <form action="modal-card-body" @submit.prevent="renameNow">
            <v-card>
              <v-toolbar dark color="darkblue">
                <v-toolbar-title>Rename folder :<i>{{ oldName }}</i></v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <label class="label">
                  New Name
                  <span class="requir has-text-danger">*</span>
                </label>
                <v-text-field label="Enter valid character" v-model.trim="newName" maxlength="100">
                </v-text-field>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="button" @click="renameModal = false">Cancel</v-btn>
                <span class="v-btn__content"><input type="submit" class="button" value="Rename" /></span>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
        <v-dialog v-model="addModalOk" :width="isUpload ? '800px' : '800px'" :active="addModalOk" :on-cancel="() => {
          (addModalOk = false),
            (folderName = ''),
            (selectedClassID = ''),
            (dropFile = []);
        }
          ">
          <div v-if="isUpload">
            <form action="modal-card-body">
              <v-card width="800px">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <label class="label">
                        {{ inputTitle }}
                        <span class="requir has-text-danger">*</span>
                      </label>
                      <span class="has-text-danger">Please Upload File in the format .mp3, .mp4, .pdf,
                        .jpg, .png, .jpeg, .ppt, .xlsm, .docx
                      </span>
                      <span class="has-text-danger">File size should not be more than 25 MB each .</span>
                      <span class="has-text-danger">File that are not supported will be removed automatically!</span>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input label="Click to upload" clear-icon="mdi-close" multiple required outlined
                        placeholder="Click to upload" v-model="dropFile" @change="onFilechange()"></v-file-input>
                      <span v-if="dropFile.length > 0">
                        <div class="tags">
                          <span class="tag is-primary" v-for="(file, i) in dropFile" :key="i">
                            {{ file.name }}
                            <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                          </span>
                        </div>
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn @click="() => {
                    (addModalOk = false), (dropFile = []);
                  }
                    ">
                    Close
                  </v-btn>
                  <v-btn color="primary" @click="uploadNow">Upload</v-btn>
                </v-card-actions>
              </v-card>
            </form>
          </div>
          <div v-else>
            <form action="modal-card-body" @submit.prevent="addFolder">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col :cols="6" v-if="!parentFolderId">
                      <label class="label">Class Group</label>
                      <v-autocomplete outlined placeholder="--Select--" name="classSelect" v-model="selectedClassID"
                        required item-value="id" :items="classes" key="id" :item-text="(item) => item.name" hide-details>
                      </v-autocomplete>
                    </v-col>
                    <v-col :cols="!parentFolderId ? '6' : '12'">
                      <label class="label">Folder Name</label>
                      <v-text-field placeholder="Enter Name" hide-details outlined v-model.trim="folderName"
                        class="pa-0 pb-0 mb-0 folderItem" required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="!parentFolderId">
                      <label class="label">Select Academic Year
                        <span class="has-text-danger">*</span></label>
                      <div class="control">
                        <span class="select is-fullwidth">
                          <select name="academicYear" v-model="academicYearID" placeholder="--Select--" required>
                            <option value="" style="color: red !important" class="placeholder">
                              Select Year
                            </option>
                            <option :value="year.id" v-for="year in academicYears" :key="year.id">
                              {{ year.academicYear }}
                            </option>
                          </select>
                        </span>
                      </div>
                    </v-col>

                    <v-col cols="12" v-if="!parentFolderId">
                      <label class="label">Select Franchisee
                        <span class="has-text-danger">*</span></label>
                      <v-checkbox v-model="flag" @change="allFranchisee" label="All Franchisee"></v-checkbox>
                      <div class="control">
                        <span class="select is-fullwidth">
                          <multiselect class="overflowmultiselect2" label="companyName" track-by="companyName"
                            :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                            :preselect-first="false" :multiple="true" :options="FranchiseeArr"
                            v-model="selectedFranchisee" required>
                          </multiselect>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <br /><br />
                <v-card-actions class="justify-end">
                  <v-btn @click="() => {
                    (addModalOk = false),
                      (folderName = ''),
                      (selectedClassID = ''),
                      (academicYearID = ''),
                      (selectedFranchisee = '');
                  }
                    ">
                    Close</v-btn>
                  <!-- <v-btn color="primary" @click="addFolder">Create</v-btn> --><span class="v-btn__content"><input
                      type="submit" class="button primary" value="Create" /></span>
                </v-card-actions>
              </v-card>
            </form>
          </div>
        </v-dialog>
        <!-- <section> -->
        <card-component>
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle">Folders</p>
              </div>
            </div>
            <div v-if="isWrite" class="level-right">
              <div class="level-item">
                <v-btn @click="modalOpen" color="primary" small right title="Add New Folder">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <hr />
          <v-row v-if="foldersArr.length > 0">
            <v-col v-for="folder in foldersArr" :key="folder.id" cols="12" lg="2">
              <v-card v-if="foldersArr.length > 0" color="orange" class="rounded-lg mx-auto pl-1" elevation="2"
                @click="getFolder(folder.id, null, folder.id)">
                <div class="d-flex flex-no-wrap justify-space-between fixed-height" style="background-color: white">
                  <div>
                    <v-card-title class="text-h5 black--text">
                      <span>
                        <v-icon color="gray" x-large>mdi-folder-outline</v-icon>
                      </span>
                      <!-- <v-spacer></v-spacer> -->
                      <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn black icon v-bind="attrs" v-on="on" absolute top right>
                            <v-icon color="gray">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item link>
                            <v-list-item-title v-if="modules.DeleteFolder" aria-role="listitem"
                              @click="deleteFolder(folder.id)">Delete</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!isMain" link>
                            <v-list-item-title v-if="modules.RenameFolder && !isMain" aria-role="listitem"
                              @click="rename(folder.id, folder.folderName.name)">Rename
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-title>
                    <v-card-subtitle>
                      <div class="shortFoldername">
                        {{ folder.folderName.name }}
                      </div>
                    </v-card-subtitle>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <p v-else>No folders here!!</p>
          <hr />
          <div class="level" v-if="!isMain">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle">Files</p>
              </div>
            </div>
            <div v-if="isWrite" class="level-right">
              <div class="level-item">
                <v-btn @click="modalOpen('upload')" title="Upload file" color="primary" small>
                  <v-icon>mdi-upload</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div>
            <table class="table is-bordered is-hoverable">
              <tbody>
                <tr v-for="file in files" :key="file.id">
                  <td class="is-flex is-justify-content-space-between">
                    <a @click="fileOpen(file)"> {{ file.name }}</a> &nbsp;
                    &nbsp; &nbsp;
                    <span class="pl-8">
                      <v-icon v-if="modules.DeleteFile" title="Delete" @click="deleteFile(file.id)">
                        mdi-delete</v-icon>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr v-if="!isMain" />
        </card-component>
        <!-- </section> -->
      </v-card>
      <loading-icon :value="isLoading" />
    </v-container>
  <pdfView :url="filePath" v-if="fileType === 'pdf'"  @close="filePath = ''"></pdfView>

  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import pdfView from './pdfView.vue'

export default {
  name: 'curriculum',
  components: {
    CardComponent,
    Multiselect,
    pdfView
  },
  props: ['folderId'],
  data () {
    return {
      modules: {
        RenameFolder: this.checkModuleAccess('RenameFolder'),
        DeleteFolder: this.checkModuleAccess('DeleteFolder'),
        DeleteFile: this.checkModuleAccess('DeleteFile')
      },
      isSuperAdmin: false,
      selectedClassID: '',
      getList: [],
      academicYears: [],
      isLoading: false,
      classes: [],
      addModalOk: false,
      folderName: '',
      franchiseeID: '',
      academicYearID: '',
      foldersArr: [],
      isMain: true,
      parentFolderId: '',
      isUpload: false,
      fileName: '',
      dropFile: [],
      inputTitle: "Select file('s)",
      renameModal: false,
      newName: '',
      oldName: '',
      renameId: '',
      idForUpload: '',
      files: [],
      flag: '',
      loadingComponent: null,
      isWrite: false,
      selectedFranchisee: [],
      FranchiseeArr: [],
      subFolderFr: true,
      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg', 'm4v', 'mp3', 'avi', 'mpg', 'mp4', 'doc', 'pptx', 'ppt', 'docx', 'docm', 'xlsb', 'xlsm', 'xls', 'pps', 'DOCX', 'PDF', 'PPT', 'PPTX', 'xlsx', 'XLSX', 'JPG', 'JPEG', 'PNG'],
      filePath: '',
      fileType: ''
    }
  },
  created: async function () {
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)

    if (this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }

    if (this.folderId) {
      this.getFolder(this.folderId, 'fromWatch')
    }
    await this.onFranchiseeChange()
    await this.getAcademicYears()
    await this.getFranchiseeList()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    window.addEventListener('keydown', this.blockPrint)
    this.getFolder(this.folderId, 'fromWatch')
    // if (this.franchisee.id) {
    await this.onFranchiseeChange()
    // }
  },
  watch: {
    franchisee: async function (val) {
      this.files = []
      this.foldersArr = []
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      this.files = []
      this.foldersArr = []
      await this.onFranchiseeChange()
    },
    folderId (val) {
      this.files = []
      this.foldersArr = []
      this.getFolder(val, 'fromWatch')
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.blockPrint)
  },
  methods: {
    blockPrint (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault()
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    deleteFile: async function (id) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/franchisee/delete-video/${id}`)
        this.okMsg('File Deleted successfully!')
        this.onFranchiseeChange()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteFolder: async function (id) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/folder/status/${id}`)
        this.okMsg('Folder Deleted successfully!')
        this.onFranchiseeChange()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    fileOpen: async function (file) {
      try {
        const extMatch = file.name.match(/\.([a-zA-Z0-9]+)$/)
        const extension = extMatch ? extMatch[1].toLowerCase() : ''
        if (extension === 'pdf') {
          let url = await http.get(
            `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${file.url}`
          )
          this.filePath = url.data
          this.fileType = extension
          return
        }
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${file.url}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
      (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },

    renameNow: async function () {
      if (!this.newName) {
        this.errMsg('Name cannot be empty!')
        return false
      }
      try {
        await http.post(
          `${constants.API_URL}/api/folder/rename/${this.renameId}`,
          {
            name: this.newName,
            academicYearID: this.academicYearID
          }
        )
        this.okMsg('Folder Renamed!!')
        this.renameModal = false
        this.newName = ''
        this.getFolder(this.folderId, 'fromWatch')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    rename (id, name) {
      this.renameModal = true
      this.renameId = id
      this.oldName = name
    },
    uploadNow: async function () {
      this.loadingComponent = this.$buefy.loading.open()
      let formData = new FormData()
      // formData.append('franchiseeID', this.franchiseeID)
      formData.append('type', 'EDUCATION')
      formData.append('folderID', this.folderId)

      for (let i = 0; i < this.dropFile.length; i++) {
        formData.append('file', this.dropFile[i])
      }

      try {
        let res = await http.post(
          `${constants.API_URL}/api/academic/upload-data`,
          formData
        )

        res.data.map((a) => {
          if (a.isBoom && a.output.payload.statusCode === 417) {
            this.errMsg(a.output.payload.message)
          } else {
            this.okMsg(`"${a.name}" uploaded successfully`)
          }
        })

        this.addModalOk = false
        this.getFolder(this.folderId, 'fromWatch')
        this.dropFile = []
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
      this.loadingComponent.close()
    },
    onFilechange () {
      let FileSize = 0
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
          FileSize = Math.floor(a.size / 1024 / 1024)
          if (FileSize > 25) {
            this.errMsg('File size should not be more than 25 MB each!')
            return false
          }
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    },
    addFolder: async function () {
      let formData = {}

      if (!this.folderName) {
        this.errMsg('Folder name cannot be empty!')
        return false
      }
      if (this.folderName !== '') {
        formData.name = this.folderName
      }
      formData.academicYearID = this.academicYearID

      if (this.isMain) {
        if (!this.selectedClassID) {
          this.errMsg('Kindly select class!')
          return false
        }
        formData.classID = this.selectedClassID
        if (this.selectedFranchisee.length === 0) {
          return this.$dialog.message.warning('Please select Franchisee', {
            position: 'top',
            timeout: 4000
          })
        }
        formData.franchiseeID = this.selectedFranchisee.map((a) => a.id)
      } else if (this.parentFolderId) {
        // this.subFolderFr = false
        formData.folderMapID = this.parentFolderId
      }

      try {
        this.loadingComponent = this.$buefy.loading.open()
        let res = await http.post(`${constants.API_URL}/api/folder`, formData)
        if (res.data === 'Folder Already Exist.') {
          this.errMsg(res.data)
        } else {
          this.okMsg(res.data)
        }
        this.addModalOk = false
        this.folderName = ''
        this.academicYear = ''
        this.academicYearID = ''
        this.selectedClassID = ''
        this.selectedFranchisee = ''
        this.loadingComponent.close()

        this.getFolder(
          this.parentFolderId ? this.parentFolderId : null,
          'fromWatch'
        )
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFolder: async function (parentId, fromWatch, uploadWalaId) {
      const loadingComponent = this.$buefy.loading.open()

      // if (!this.franchiseeID && !this.isSuperAdmin) {
      //   this.errMsg('Please select Franchisee')
      // }
      // if (uploadWalaId) {
      //   this.idForUpload = uploadWalaId
      // }

      let url = ''

      // if (parentId) {
      //   // get subfolders
      //   url = `${constants.API_URL}/api/folder?folderMapID=${parentId}&&academicYearID=${this.academicYearID}&&franchiseeID=${this.franchiseeID}`
      //   if (!fromWatch) {
      //     this.$router.push({ name: 'folder', params: { folderId: parentId } })
      //   }
      // } else {
      //   // get main folder
      //   url = `${constants.API_URL}/api/folder?academicYearID=${this.academicYearID}&&franchiseeID=${this.franchiseeID}`
      // }
      if (parentId) {
        // get subfolders
        url = `${constants.API_URL}/api/folder?franchiseeID=${this.franchiseeID}&&folderMapID=${parentId}&&classGroupID=${this.selectedClassID}`
        if (!fromWatch) {
          this.$router.push({ name: 'folder', params: { folderId: parentId } })
        }
      } else if (this.franchiseeID) {
        // get main folder
        url = `${constants.API_URL}/api/folder?academicYearID=${this.academicYearID}`
      } else if (this.isSuperAdmin) {
        url = `${constants.API_URL}/api/folder?academicYearID=${this.academicYearID}`
      }
      if (url) {
        try {
          const { data } = await http.get(url)

          this.foldersArr = data.folders
          this.files = data.files
          this.isMain = !parentId
          this.parentFolderId = parentId
          let newAcademicYearID = ''
          let folderArrTemp = this.foldersArr
          if (!_.isEmpty(folderArrTemp)) {
            folderArrTemp = folderArrTemp[0]
            newAcademicYearID = folderArrTemp.academicYearID
          }

          if (newAcademicYearID) {
            this.academicYearID = newAcademicYearID
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          // this.errMsg(errorMessage)
          console.log(errorMessage)
        }
      }
      loadingComponent.close()
    },

    modalOpen (mode) {
      this.addModalOk = true
      this.isUpload = mode === 'upload'
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.curriculum &&
            e.isActive === true
          )
        })
        this.classes = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassListByGroupID: async function (objClassID) {
      this.hasClicked = true
      this.loader = true
      this.getList = []
      this.mappingData = []
      if (objClassID) {
        let classGroupID = objClassID
        try {
          const { data } = await http.get(
            `${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`
          )
          this.mappingData = data
          let selectedClassObj = []
          if (this.mappingData) {
            const objectArray = Object.entries(this.mappingData)
            objectArray.forEach(([key, value]) => {
              value.studentClasses.map(function (k) {
                selectedClassObj.push(k.name)
              })
            })
            this.getList = selectedClassObj.join(', ')
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(
            `Error While getting Class Group Mapping: ${errorMessage}`
          )
        }
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = res.data
        this.FranchiseeArr = data.rows
        console.log(this.FranchiseeArr, 'Franchisee Test')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    // getClassList: async function () {
    //   try {
    //     const { data } = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=false`)
    //     if (data) {
    //       this.classes = data
    //     }
    //   } catch (e) {
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     this.errMsg(errorMessage)
    //   }
    // },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        // if (this.franchiseeID && this.academicYearID) {
        // if (this.academicYearID) {
        await this.getClassList()
        // }
        this.currentPage = 1
        this.inProgress = false
      }
      // if (this.franchiseeID) {
      this.getFolder(this.folderId, 'fromWatch')
      // }
    },
    // Added method

    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },

    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.FranchiseeArr.forEach((Obj) => {
          franchiseeArray.push(Obj)
        })
        this.flag = true
      }
      this.selectedFranchisee = franchiseeArray
    }
  }
}
</script>
<style scoped>
.v-text-field--outlined>.v-input__control>.v-input__slot {
  min-height: 32px !important;
}

.v-input__control .v-text-field__details {
  margin-bottom: 0px !important;
}

.tile.is-child {
  border: 1px solid #ff000059;
}

.fol-name {
  overflow-wrap: break-word;
}

.foldr {
  cursor: pointer;
}

.is-justify-content-space-between {
  justify-content: space-between;
}

/* .shortFoldername {
  width: 155px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
.shortFoldername div {
  padding: 0 20px;
}

@media (min-width: 375px) and (max-width: 477px) {
  .v-btn--absolute.v-btn--right.v-btn--top {
    margin-top: 0px !important;
  }
}

@media screen and (min-width: 800px) {
  .fixed-height {
    height: 100px;
  }

  .shortFoldername {
    width: 155px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .shortFoldername:hover {
    background: #eaeaea;
    border: 1px solid #ccc;
    position: relative;
    z-index: 9;
    left: 0;
    white-space: initial;
    min-height: 50px;
    min-width: 100px;
    padding: 5px;
    border-radius: 4px;
  }
}

@media screen and (max-width: 600px) {
  .shortFoldername {
    display: block;
    position: relative;
    /* width: 26px; */
    word-break: break-all;
  }
}
.preventclick {
  /* Prevent user from selecting/copying text */
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  /* Prevent right click context menu */
  -webkit-touch-callout: none !important;
}

/* Prevent right click context menu */
.preventclick,
.preventclick * {
  pointer-events: auto !important;
}

.preventclick {
  -webkit-touch-callout: none !important;
}

@media print {
  .preventclick, .preventclick * {
    display: none !important;
  }
}
.placeholder {}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
